const StickyCtaMap = new Map();

StickyCtaMap.set(
  "_default",
  "https://merchant.cashfree.com/merchants/signup?source-action=Home%20page&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "payment-gateway-india",
  "https://merchant.cashfree.com/merchants/signup?source-action=PG%20Page&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "payouts",
  "https://merchant.cashfree.com/merchants/signup?source-action=Payout%20Page&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "payment-forms",
  "https://merchant.cashfree.com/merchants/signup?source-action=payment%20forms&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "payment-links",
  "https://merchant.cashfree.com/merchants/signup?source-action=payment%20links&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "soft-pos",
  "https://merchant.cashfree.com/merchants/signup?source-action=softpos&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "PAN-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=PAN%20Verification%20Page&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "aadhaar-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=aadhaar%20verification&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "card-tokenization",
  "https://merchant.cashfree.com/merchants/signup?source-action=tokenvault&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "cred",
  "https://merchant.cashfree.com/merchants/signup?source-action=CRED%20Case%20Study&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "ritu-kumar",
  "https://merchant.cashfree.com/merchants/signup?source-action=RituKumar%20Case%20Study&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "gst-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=gstin%20verification&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "working-capital-loan",
  "https://merchant.cashfree.com/merchants/signup?source-action=Advances%20page&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "wix-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=wix%20payment%20gateway&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "report-socialmedia-issue",
  "https://merchant.cashfree.com/merchants/signup?source-action=Social%20Media%ReportPage&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "upi-qr-code",
  "https://merchant.cashfree.com/merchants/signup?source-action=upi%20qr%20code&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "events",
  "https://merchant.cashfree.com/merchants/signup?source-action=Events%20Page&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "upi-autopay",
  "https://merchant.cashfree.com/merchants/signup?source-action=upi%20autopay&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "cashgram",
  "https://merchant.cashfree.com/merchants/signup?source-action=Cashgram%20Page&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "card-issuance",
  "https://merchant.cashfree.com/merchants/signup?source-action=card%20issuance&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "instant-settlements",
  "https://merchant.cashfree.com/merchants/signup?source-action=Instant%20settlements&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "easy-split",
  "https://merchant.cashfree.com/merchants/signup?source-action=easy%20split&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "buy-now-pay-later",
  "https://merchant.cashfree.com/merchants/signup?source-action=BNPL&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "global-payments",
  "https://merchant.cashfree.com/merchants/signup?source-action=international%20wire%20transfer&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);

StickyCtaMap.set(
  "embedded-lending",
  "https://merchant.cashfree.com/merchants/signup?source-action=Embedded%20lending&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "api-banking-india",
  "https://merchant.cashfree.com/merchants/signup?source-action=API%20banking%20India&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "connected-banking",
  "https://merchant.cashfree.com/merchants/signup?source-action=Connected%20Banking&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "shopify-payment-gateway-india",
  "https://merchant.cashfree.com/merchants/signup?source-action=Shopify%20Page&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "grievance-redressal-policy",
  "https://merchant.cashfree.com/merchants/signup?source-action=grievance%20redressal&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "outward-remittance",
  "https://merchant.cashfree.com/merchants/signup?source-action=Outward%20remittance&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "partner-program",
  "https://partner.cashfree.com/partner-ui/authentication/signup?source-action=partner%20program&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "enach",
  "https://merchant.cashfree.com/merchants/signup?source-action=eNACH&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "connected-banking",
  "https://merchant.cashfree.com/merchants/signup?source-action=Connected%20Banking&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "kyc-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=Verification%20Suite&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "nbfc",
  "https://merchant.cashfree.com/merchants/signup?source-action=NBFC%20lending%20solution&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "upi-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=UPI%20PG&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "ecommerce-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=ecommerce%20lp&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "support",
  "https://merchant.cashfree.com/merchants/signup?source-action=Support&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "yes-bank-cashfree",
  "https://merchant.cashfree.com/merchants/signup?source-action=Yes%20Bank%20CFWebinar&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "about-us",
  "https://merchant.cashfree.com/merchants/signup?source-action=About%20Us&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "payment-gateway-charges",
  "https://merchant.cashfree.com/merchants/signup?source-action=Pricing%20Page&action=Sign%20Up&button-id=GetStarted_MobileStickyNav",
);
StickyCtaMap.set(
  "smart-sell-affordablity",
  "https://merchant.cashfree.com/merchants/signup?source-action=SmartSell%20Affordablity&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "online-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=Online%20Payment%20Gateway&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "freelancer-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=Freelancer%20Payment%20Gateway&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "debit-card-emi",
  "https://merchant.cashfree.com/merchants/signup?source-action=Debit%20Card%20EMI&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "privacypolicy",
  "https://merchant.cashfree.com/merchants/signup?source-action=Privacy%20Policy&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "paymentservices_tnc",
  "https://merchant.cashfree.com/merchants/signup?source-action=Payment%20Services%20TnC&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "tnc",
  "https://merchant.cashfree.com/merchants/signup?source-action=TnC&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "whitepapers/optimizing-transaction-success-rate",
  "https://merchant.cashfree.com/merchants/signup?source-action=hsr%20ebook&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "settlement-and-reconciliation-guide",
  "https://merchant.cashfree.com/merchants/signup?source-action=Settlement%20Reconciliation%20Guide&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "preauthorization",
  "https://merchant.cashfree.com/merchants/signup?source-action=Pre%20Auth&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "send-money-to-india/global-payouts",
  "https://merchant.cashfree.com/merchants/signup?source-action=global%20payouts%20lp&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "kyc-link",
  "https://merchant.cashfree.com/merchants/signup?source-action=kyc%20link&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "bbps-biller",
  "https://merchant.cashfree.com/merchants/signup",
);
StickyCtaMap.set(
  "cb-partner-solutions/global-trade-plaza",
  "https://merchant.cashfree.com/merchants/signup?source-action=PartnerSolution%20CB%20GTP&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "accelerated-onboarding",
  "https://merchant.cashfree.com/merchants/signup?source-action=accelerated%20onboarding&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "growth/cross-border-for-exporters",
  "https://merchant.cashfree.com/merchants/signup?referrer=partner&refCode=CFPSL972619",
);
StickyCtaMap.set(
  "international-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=International%20Payment%20Gateway&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "affiliate-program",
  "https://partner.cashfree.com/partner-ui/authentication/signup?source-action=Affiliate%20Program%20LP&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "how-to-choose-the-right-payment-stack-for-optimal-subscription-management",
  "https://merchant.cashfree.com/merchants/signup?source-action=Ebook%20Subscription%20Management&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "digilocker-api",
  "https://merchant.cashfree.com/merchants/signup?source-action=DigiLocker%20API%20LP&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "face-match-api",
  "https://merchant.cashfree.com/merchants/signup?source-action=Face%20Match%20API%20LP&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "driving-license-verification-api",
  "https://merchant.cashfree.com/merchants/signup?source-action=DL%20Verification%20API%20LP&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "geolocation-api",
  "https://merchant.cashfree.com/merchants/signup?source-action=GeoLocation%20API&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "aadhaar-esign",
  "https://merchant.cashfree.com/merchants/signup?source-action=Aadhaar%20eSign&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "passport-verification-api",
  "https://merchant.cashfree.com/merchants/signup?source-action=Passport%20Verification%20API&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "employee-background-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=Employee%20Background%20Verification&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "zoho-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=Zoho%20Integration&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "employee-background-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=Employee%20Background%20Verification&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "zoho-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=Zoho%20Integration&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "IFSC-verification-api",
  "https://merchant.cashfree.com/merchants/signup?source-action=IFSC%20Verification%20API&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "gst-search-by-pan",
  "https://merchant.cashfree.com/merchants/signup?source-action=GST%20Search%20by%20PAN&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "accept-international-payments",
  "https://merchant.cashfree.com/merchants/signup?source-action=Accept%20International%20Payments&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "voter-id-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=Voter%20ID%20Verification&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "customer-reward-scheme-terms-and-conditions",
  "https://merchant.cashfree.com/merchants/signup?source-action=CustomerReward%20TnC&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "aadhaar-masking",
  "https://merchant.cashfree.com/merchants/signup?source-action=Aadhaar%20Masking%20API&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "rc-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=RC%20Verification%20API&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "aadhaar-ocr-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=Aadhaar%20OCR%20Verification&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "digital-onboarding",
  "https://merchant.cashfree.com/merchants/signup?source-action=Digital%20Onboarding&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "kyb-solutions",
  "https://merchant.cashfree.com/merchants/signup?source-action=KYB%20Solutions%20LP&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "digital-kyc",
  "https://merchant.cashfree.com/merchants/signup?source-action=Digital%20KYC&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "automated-kyc",
  "https://merchant.cashfree.com/merchants/signup?source-action=Automated%20KYC&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "risk-shield-for-payment-disbursal",
  "https://merchant.cashfree.com/merchants/signup?source-action=RiskShield%20Payouts&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "beneficiary-verification",
  "https://merchant.cashfree.com/merchants/signup?source-action=Beneficiary%20Verification&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "risk-shield-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=RiskShield%20PG&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "checkout-one",
  "https://merchant.cashfree.com/merchants/signup?source-action=CheckOut%20One&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "news-room",
  "https://merchant.cashfree.com/merchants/signup?source-action=News%20Room&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "d2c-payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=D2C%20PG&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "developer-code-of-conduct",
  "https://merchant.cashfree.com/merchants/signup?source-action=Developer%20Code%20Conduct&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "prefill-api",
  "https://merchant.cashfree.com/merchants/signup?source-action=Prefill%20API&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "kyc-studio",
  "https://merchant.cashfree.com/merchants/signup?source-action=KYC%20Studio&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "payment-gateway",
  "https://merchant.cashfree.com/merchants/signup?source-action=PG1%20Paid&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "demo/one-click-checkout-demo",
  "https://www.cashfree.com/contact-sales/?source-action=Demo%20One%20Click%20Checkout&action=Contact%20Sales&button-id=ContactSales_TestItNow",
);
StickyCtaMap.set(
  "one-click-checkout",
  "https://merchant.cashfree.com/merchants/signup?source-action=OneClick%20festive%20Paid&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "payment-pages",
  "https://merchant.cashfree.com/merchants/signup?source-action=payment%20pages&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "embedded-payments",
  "https://partner.cashfree.com/partner-ui/authentication/signup?source-action=Embedded%20Payments&action=Sign%20Up&button-id=StartNow_Navbar",
);
StickyCtaMap.set(
  "settlement-holidays",
  "https://merchant.cashfree.com/merchants/signup?source-action=Settlement%20Holidays&action=Sign%20Up&button-id=StartNow_Navbar",
);

export default StickyCtaMap;
